import { SalesOrderGridModel } from '../features/Order/models/SaleOrderGridModel';
import { SaleOrderEntityModel } from '../features/Order/models/SaleOrderEntityModel';
import { convertOrderEntityGridModel, convertOrderEntityToRMAGridModel, convertOrderEntityToPaymentGridModel } from '../features/Order/services/OrderService';
import { QueryDocumentRecordsModel } from "./DataServiceModels";
import { API_SERVER_URL, CLOUD_FUNCTIONS } from "../shared/config/constants";
import { getIdTokenFromLocalStorage } from "./DataService";
import { OrdersReprocessRequest, OrderReprocessRequest } from "../features/Order/models";
import firebase from "../shared/config/firebaseConfig";
import { DATABASE_COLLECTIONS, STATIC_DOCUMENTS_ID } from '../shared/config/constants';
import { Observable } from 'rxjs';
import { writeException } from "../shared/services/LoggingService";
import _ from 'lodash';
// const { REPROCESS_BULK_ORDERS, ORDER_PROCESSING_NETO_TO_MYOB_TASK } = CLOUD_FUNCTIONS;
const { REPROCESS_BULK_ORDERS, ORDER_PROCESSING_NETO_TO_MYOB_TASK, MARK_AS_CLOSE_ORDERS, RE_EXPORT_NETO_RMA_TO_MYOB } = CLOUD_FUNCTIONS;
const db = firebase.firestore();
const { USER_DETAILS, CONNECTORS, ORDERS, RECORDCOUNTER } = DATABASE_COLLECTIONS;
const { ORDER } = STATIC_DOCUMENTS_ID;
export let getOrderSnapshotUnsubscribe: any
export let getOrderRecordCount: any

const makeSearchClauses = (ordersRef: firebase.firestore.Query<firebase.firestore.DocumentData>, query: any, sortField: string, sortOrder: number, mode?: string) => {

  let ref = ordersRef;
  if (query && query.length > 0) {
    query?.map((q: any) => {
      if (q?.key === "Date") {
        if (mode && mode === 'ALL') {
          ref = ref.where(q?.key, '>=', q?.value?.startAt).where(q?.key, '<=', q?.value?.endAt);
        } else {
          ref = ref.where(q?.key, '>=', q?.value?.startAt).where(q?.key, '<=', q?.value?.endAt).orderBy(q?.key);
        }
      }
      else if (q?.key === "OutgoingOrder.Status" || q?.key === "IncomingOrder.OrderStatus" || q?.key === "Status") {
        if (mode && mode === 'ALL') {
          ref = ref.where(q?.key, '>=', q?.value).where(q?.key, '<=', q?.value + '\uf8ff').orderBy(q?.key);
        } else {
          ref = ref.where(q?.key, '>=', q?.value).where(q?.key, '<=', q?.value + '\uf8ff').orderBy(q?.key).orderBy(sortField, sortOrder === -1 ? 'desc' : 'asc');
        }
      }
      else if (q?.key === "RmaIncoming.RmaID") {
        ref = ref.where('RMA', 'array-contains', { NetoRmaId: q?.value }).orderBy("RMA");
      }
      else {
        ref = ref.where(q?.key, '>=', q?.value).where(q?.key, '<=', q?.value + '\uf8ff').orderBy(q?.key);
      }
    })
  }
  return ref;
}

export const getOrdersFromServer = async (
  userId: string,
  connector: string,
  limit: number,
  sortField: string,
  sortOrder: number,
  firstVisible?: string,
  lastVisible?: string,
  mode?: string,
  query?: { key: string; value: any; }[]
) => {
  // return new Observable(subscriber => {
  // const processRequest = async () => {
  try {
    const idToken = await getIdTokenFromLocalStorage();
    // Prepare the request data
    const requestData = {
      userId,
      connector,
      limit,
      sortField,
      sortOrder,
      firstVisibleId: firstVisible,
      lastVisibleId: lastVisible,
      mode,
      query: query ? JSON.parse(JSON.stringify(query)) : null
    };

    console.log("Fetching orders with params:", requestData);
    const response = await fetch(`${API_SERVER_URL}/orders`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `${idToken}`
      },
      body: JSON.stringify(requestData)
    });

    if (!response?.ok) {
      const error = await response?.json();
      throw new Error(error?.message || 'Failed to fetch orders');
    }

    const data = await response?.json();

    // Process the orders data
    const ordersData = data?.orders?.map((entity: SaleOrderEntityModel, index: number) => {
      const order = convertOrderEntityGridModel(entity, index);
      order.documentId = entity?.id; // Ensure ID is preserved
      return order;
    }) as SalesOrderGridModel[]

    // Handle new order highlighting
    if (ordersData?.length > 0) {
      const latestDateOrder = ordersData?.map(e => e?.datePlaced)?.sort().reverse()[0];
      const findIndex = ordersData?.findIndex(order => order?.datePlaced === latestDateOrder);
      if (findIndex >= 0) {
        ordersData[findIndex].new = true;
      }
    }

    // Create document references for pagination
    const firstDocId = data?.firstDocId ? data?.firstDocId : null;
    const lastDocId = data?.lastDocId ? data?.lastDocId : null;
    return {
      ordersData,
      firstDocId,
      lastDocId
    }
    // subscriber.next({
    //   ordersData,
    //   firstDocId,
    //   lastDocId
    // });
    // subscriber?.complete();

  } catch (error: any) {
    console.error('Error in getOrdersFromServer:', error);
    // subscriber?.error(error);
  }
};

// processRequest();
// });
// };

// In OrderDataService.ts

export const getFailedOrdersFromServer = (
  userId: string,
  connector: string,
  limit: number,
  sortField: string = 'Date',
  sortOrder: number = -1,
  firstVisible?: string,
  lastVisible?: string,
  mode?: string,
  query?: Array<{ key: string; value: any }>,
  includeHistory?: boolean
): Observable<{
  ordersData: SalesOrderGridModel[];
  firstDocId: string;
  lastDocId: string;
}> => {
  return new Observable(subscriber => {
    const processRequest = async () => {
      try {
        const idToken = await getIdTokenFromLocalStorage();

        // Prepare the request data
        const requestData = {
          userId,
          connector,
          limit,
          sortField,
          sortOrder,
          firstVisibleId: firstVisible,
          lastVisibleId: lastVisible,
          mode,
          query: query || [],
          // Only sent (and honoured) for the ordinary default failed view; lifts the
          // 60-day source-DatePlaced horizon so historical failures are included.
          includeHistory: includeHistory === true
        };
        console.log("Fetching failed orders with params:", requestData);
        const response = await fetch(`${API_SERVER_URL}/orders/failed`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `${idToken}`
          },
          body: JSON.stringify(requestData)
        });

        if (!response?.ok) {
          const error = await response?.json();
          throw new Error(error?.message || 'Failed to fetch failed orders');
        }

        const data = await response?.json();

        // Process the orders data
        const ordersData = data?.ordersData?.map((entity: SaleOrderEntityModel, index: number) => {
          const order = convertOrderEntityGridModel(entity, index);
          order.documentId = entity?.id;
          return order;
        }) as SalesOrderGridModel[]

        // Handle new order highlighting
        if (ordersData?.length > 0) {
          const latestDateOrder = ordersData
            .map(e => e?.datePlaced)
            .sort()
            .reverse()?.[0];

          const findIndex = ordersData.findIndex(
            order => order?.datePlaced === latestDateOrder
          );

          if (findIndex >= 0) {
            ordersData[findIndex].new = true;
          }
        }

        subscriber.next({
          ordersData,
          firstDocId: data?.firstDocId,
          lastDocId: data?.lastDocId
        });
        subscriber.complete();

      } catch (error) {
        console.error('Error in getFailedOrdersFromServer:', error);
        subscriber.error(error);
      }
    };

    processRequest();
  });
};

export const getOrderByIdFromServer = async (userId: string, connectorId: string, orderId: string) => {
  try {
    const idToken = await getIdTokenFromLocalStorage();
    const response = await fetch(`${API_SERVER_URL}/orders/${userId}/${connectorId}/${orderId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `${idToken}`
      }
    });
    if (!response?.ok) {
      const error = await response?.json();
      throw new Error(error?.message || 'Failed to fetch order by ID');
    }
    const data = await response?.json();
    return data;
  } catch (error) {
    console.error('Error in getOrderByIdFromServer:', error);
    throw new Error('Failed to fetch order by ID');
  }
}

export const getOrdersFromFirebase = (userId: string, connector: string, limit: number, sortField: string, sortOrder: number,
  firstVisible?: any, lastVisible?: any, mode?: string, query?: any) => {
  return new Observable(subscriber => {
    console.log("ORDER-GRID sortField: ", sortField);
    console.log("ORDER-GRID query: ", query)

    let ordersRef: firebase.firestore.Query<firebase.firestore.DocumentData> | undefined = undefined;
    if (lastVisible && mode === 'NEXT') {
      ordersRef = db.collection(`${USER_DETAILS}`).doc(userId)
        .collection(`${CONNECTORS}`).doc(connector)
        .collection(`${ORDERS}`).where('Status', "in", ['Imported', 'ExportComplete', 'ExportStart', 'ImportComplete', 'ImportStart']); //.orderBy(sortField, sortOrder === -1 ? 'desc' : 'asc');
      if (!_.isEmpty(query)) {
        ordersRef = makeSearchClauses(ordersRef, query, sortField, sortOrder);
        ordersRef = ordersRef.startAfter(lastVisible).limit(limit);
      } else {
        ordersRef = ordersRef.orderBy(sortField, sortOrder === -1 ? 'desc' : 'asc').startAfter(lastVisible).limit(limit);
      }
    }
    else if (firstVisible && mode === 'PREV') {
      ordersRef = db.collection(`${USER_DETAILS}`).doc(userId)
        .collection(`${CONNECTORS}`).doc(connector)
        .collection(`${ORDERS}`).where('Status', "in", ['Imported', 'ExportComplete', 'ExportStart', 'ImportComplete', 'ImportStart']); //.orderBy(sortField, sortOrder === -1 ? 'desc' : 'asc');
      if (!_.isEmpty(query)) {
        ordersRef = makeSearchClauses(ordersRef, query, sortField, sortOrder);
        ordersRef = ordersRef.endBefore(firstVisible).limitToLast(limit);
      } else {
        ordersRef = ordersRef.orderBy(sortField, sortOrder === -1 ? 'desc' : 'asc').endBefore(firstVisible).limitToLast(limit);
      }
    }
    else if (mode === 'ALL') {
      ordersRef = db.collection(`${USER_DETAILS}`).doc(userId)
        .collection(`${CONNECTORS}`).doc(connector)
        .collection(`${ORDERS}`).where('Status', "in", ['Imported', 'ExportComplete', 'ExportStart', 'ImportComplete', 'ImportStart']); //.orderBy(sortField, sortOrder === -1 ? 'desc' : 'asc');
      if (!_.isEmpty(query)) {
        ordersRef = makeSearchClauses(ordersRef, query, sortField, sortOrder, 'ALL');
        ordersRef = ordersRef.orderBy(sortField, sortOrder === -1 ? 'desc' : 'asc');
      }
      else {
        ordersRef = ordersRef.orderBy(sortField, sortOrder === -1 ? 'desc' : 'asc');
      }
    }
    else {
      ordersRef = db.collection(`${USER_DETAILS}`).doc(userId)
        .collection(`${CONNECTORS}`).doc(connector)
        .collection(`${ORDERS}`).where('Status', "in", ['Imported', 'ExportComplete', 'ExportStart', 'ImportComplete', 'ImportStart']); //.orderBy(sortField, sortOrder === -1 ? 'desc' : 'asc');
      if (!_.isEmpty(query)) {
        ordersRef = makeSearchClauses(ordersRef, query, sortField, sortOrder);
        ordersRef = ordersRef.limit(limit)
      } else {
        ordersRef = ordersRef?.orderBy(sortField, sortOrder === -1 ? 'desc' : 'asc').limit(limit)
      }
    }

    if (ordersRef) {
      getOrderSnapshotUnsubscribe = ordersRef?.onSnapshot((snapshot) => {
        let ordersData: Array<SalesOrderGridModel> = [];
        snapshot?.docs.map((doc: any, index: number) => {
          let entity: SaleOrderEntityModel = doc?.data();
          entity = { ...entity, id: doc?.id };
          ordersData.push(convertOrderEntityGridModel(entity, index));
        });
        if (ordersData.length) {
          let latestDateOrder = ordersData.map((e) => {
            return e.datePlaced;
          }).sort().reverse()[0];
          let findIndex = ordersData.findIndex((orders) =>
            orders.datePlaced === latestDateOrder
          );
          if (findIndex >= -1) {
            ordersData[findIndex].new = true;
          }
        }
        let lastRecord = snapshot?.docs?.[snapshot?.docs?.length - 1];
        let firstRecord = snapshot?.docs?.[0];
        // console.log("LAST RECORD: ", lastRecord);
        // console.log("FIRST RECORD: ", firstRecord);
        subscriber.next({ ordersData: ordersData, startBefore: firstRecord, startAfter: lastRecord });
      });
    }
  })
}



export const reprocessOrdersRequest = (
  userId: string,
  connectorId: string,
  body: OrdersReprocessRequest,
  isForced?: boolean
): Promise<QueryDocumentRecordsModel> => {
  return new Promise(async (resolve, reject) => {
    try {
      console.log('OrderDataService reprocessOrdersRequest 131: ', connectorId);
      const idToken = await getIdTokenFromLocalStorage();
      let res = await fetch(
        `${API_SERVER_URL}/${REPROCESS_BULK_ORDERS}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${idToken}`,
          },
          body: JSON.stringify({
            connectorId,
            userId,
            orderData: body.orders,
            isForced
          }),
        }
      );
      if (res.ok) {
        resolve({ isSucceed: true });
      } else {
        resolve({ isSucceed: false });
      }
    } catch (e: any) {
      resolve({ isSucceed: false, errorMessage: e.message });
      await writeException(`ErrorMessage: ${e.message}, UserID: ${userId}, ConnectorID: ${connectorId}`);
    }
  });
};

export const markAsCloseOrdersRequestRequest = (
  userId: string,
  connectorId: string,
  body: Array<string>,
): Promise<QueryDocumentRecordsModel> => {
  return new Promise(async (resolve, reject) => {
    try {
      const idToken = await getIdTokenFromLocalStorage();
      let res = await fetch(
        `${API_SERVER_URL}/${MARK_AS_CLOSE_ORDERS}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${idToken}`,
          },
          body: JSON.stringify({
            connectorId,
            userId,
            orderIds: body
          }),
        }
      );
      if (res.ok) {
        resolve({ isSucceed: true });
      } else {
        resolve({ isSucceed: false });
      }
    } catch (e: any) {
      resolve({ isSucceed: false, errorMessage: e.message });
      await writeException(`ErrorMessage: ${e.message}, UserID: ${userId}, ConnectorID: ${connectorId}`);
    }
  });
};

export const reprocessOrderRequest = (
  body: OrderReprocessRequest
): Promise<QueryDocumentRecordsModel> => {
  return new Promise(async (resolve, reject) => {
    try {
      const idToken = await getIdTokenFromLocalStorage();
      let res = await fetch(`${API_SERVER_URL}/${ORDER_PROCESSING_NETO_TO_MYOB_TASK}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': "application/json",
            Authorization: `${idToken}`,
          },
          body: JSON.stringify(body)
        }
      );
      if (res.ok) {
        resolve({ isSucceed: true });
      } else {
        let response = await res.json();
        resolve({ isSucceed: false, errorMessage: response.message });
      }
    } catch (e: any) {
      resolve({ isSucceed: false, errorMessage: e.message });
      await writeException(`ErrorMessage: ${e.message}`);
    }
  });
};

export const reExportOrderRMARequest = (
  body: OrderReprocessRequest
): Promise<QueryDocumentRecordsModel> => {
  return new Promise(async (resolve, reject) => {
    try {
      const idToken = await getIdTokenFromLocalStorage();
      let res = await fetch(`${API_SERVER_URL}/${RE_EXPORT_NETO_RMA_TO_MYOB}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': "application/json",
            Authorization: `${idToken}`,
          },
          body: JSON.stringify(body)
        }
      );
      if (res.ok) {
        resolve({ isSucceed: true });
      } else {
        let response = await res.json();
        resolve({ isSucceed: false, errorMessage: response.message });
      }
    } catch (e: any) {
      resolve({ isSucceed: false, errorMessage: e.message });
      await writeException(`ErrorMessage: ${e.message}`);
    }
  });
};


export const getFailedOrdersFromFirebaseOld = (userId: string, connector: string) => {
  return new Observable(subscriber => {
    getOrderSnapshotUnsubscribe = db.collection(`${USER_DETAILS}`).doc(userId)
      .collection(`${CONNECTORS}`).doc(connector)
      .collection(`${ORDERS}`).where("Status", "in", ['ExportFailed', 'ImportFailed', 'NotProcessed', 'ImportStart', 'ExportStart']).onSnapshot((snapshot) => {
        let ordersData: Array<SalesOrderGridModel> = [];
        snapshot?.docs.map((doc: any, index: number) => {
          let entity: SaleOrderEntityModel = doc?.data();
          entity = { ...entity, id: doc?.id };
          ordersData.push(convertOrderEntityGridModel(entity, index));
        });
        if (ordersData.length) {
          let latestDateOrder = ordersData.map((e) => {
            return e.datePlaced;
          }).sort().reverse()[0];
          let findIndex = ordersData.findIndex((orders) =>
            orders.datePlaced === latestDateOrder
          );
          if (findIndex >= -1) {
            ordersData[findIndex].new = true;
          }
        }
        subscriber.next(ordersData);
      });
  })
}


export const getOrdersFromFirebaseOld = (userId: string, connector: string) => {
  return new Observable(subscriber => {
    getOrderSnapshotUnsubscribe = db.collection(`${USER_DETAILS}`).doc(userId)
      .collection(`${CONNECTORS}`).doc(connector)
      .collection(`${ORDERS}`).onSnapshot((snapshot) => {
        let ordersData: Array<SalesOrderGridModel> = [];
        snapshot?.docs.map((doc: any, index: number) => {
          let entity: SaleOrderEntityModel = doc?.data();
          entity = { ...entity, id: doc?.id };
          ordersData.push(convertOrderEntityGridModel(entity, index));
        });
        if (ordersData.length) {
          let latestDateOrder = ordersData.map((e) => {
            return e.datePlaced;
          }).sort().reverse()[0];
          let findIndex = ordersData.findIndex((orders) =>
            orders.datePlaced === latestDateOrder
          );
          if (findIndex >= -1) {
            ordersData[findIndex].new = true;
          }
        }
        subscriber.next(ordersData);
      });
  })
}

// PG-backed replacements for getPaymentFromFirebase/getRMAFromFirebase below — these hit
// the backend's /payments and /rmas REST endpoints (order_payments/order_rmas joined to
// their owning Order server-side), instead of an unbounded client-side Firestore
// onSnapshot listener over every Order document. Kept as async functions (not Observables)
// since there's no live-listener requirement here; callers just await + setState.
export const getPaymentsFromServer = async (userId: string, connector: string, sinceDate: string) => {
  try {
    const idToken = await getIdTokenFromLocalStorage();
    const params = new URLSearchParams({ userId, connector, sinceDate });
    const response = await fetch(`${API_SERVER_URL}/payments?${params.toString()}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `${idToken}`
      }
    });
    if (!response?.ok) {
      const error = await response?.json();
      throw new Error(error?.message || 'Failed to fetch payments');
    }
    return await response?.json();
  } catch (error) {
    console.error('Error in getPaymentsFromServer:', error);
    throw error;
  }
};

export const getRmasFromServer = async (userId: string, connector: string, sinceDate: string) => {
  try {
    const idToken = await getIdTokenFromLocalStorage();
    const params = new URLSearchParams({ userId, connector, sinceDate });
    const response = await fetch(`${API_SERVER_URL}/rmas?${params.toString()}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `${idToken}`
      }
    });
    if (!response?.ok) {
      const error = await response?.json();
      throw new Error(error?.message || 'Failed to fetch RMAs');
    }
    return await response?.json();
  } catch (error) {
    console.error('Error in getRmasFromServer:', error);
    throw error;
  }
};

export const getRMAFromFirebase = (userId: string, connector: string, paymentDateFilter: string, sortOrder: number = -1) => {
  return new Observable(subscriber => {
    getOrderSnapshotUnsubscribe = db.collection(`${USER_DETAILS}`).doc(userId)
      .collection(`${CONNECTORS}`).doc(connector)
      .collection(`${ORDERS}`)
      .where('Status', "in", ['Imported', 'ExportComplete', 'ExportStart', 'ImportComplete', 'ImportStart'])
      .where('Date', '>=', paymentDateFilter).orderBy('Date', sortOrder === -1 ? 'desc' : 'asc').orderBy("RMA")
      .onSnapshot((snapshot) => {
        let rmaData: Array<any> = [];
        snapshot?.docs.map((doc: any, index: number) => {
          let entity: SaleOrderEntityModel = doc?.data();
          entity = { ...entity, id: doc?.id };
          for (const singleRMA of entity?.RMA) {
            rmaData.push(convertOrderEntityToRMAGridModel(singleRMA, entity, index));
          }
        });
        subscriber.next({ rmaData });
      });
  })
}

export const getPaymentFromFirebase = (userId: string, connector: string, paymentDateFilter: string, sortOrder: number = -1) => {
  return new Observable(subscriber => {
    getOrderSnapshotUnsubscribe = db.collection(`${USER_DETAILS}`).doc(userId)
      .collection(`${CONNECTORS}`).doc(connector)
      .collection(`${ORDERS}`)
      .where('Status', "in", ['Imported', 'ExportComplete', 'ExportStart', 'ImportComplete', 'ImportStart'])
      .where('Date', '>=', paymentDateFilter).orderBy('Date', sortOrder === -1 ? 'desc' : 'asc').orderBy("Payments")
      .onSnapshot((snapshot) => {
        let paymentData: Array<any> = [];
        snapshot?.docs.map((doc: any, index: number) => {
          let entity: any = doc?.data();
          entity = { ...entity, id: doc?.id };
          for (let singlePayment of entity?.Payments?.payments) {
            paymentData.push(convertOrderEntityToPaymentGridModel(singlePayment, entity, index));
          }
        });
        subscriber.next({ paymentData });
      });
  })
}

/**
 * Grouped order-status counts for the admin "Orders Counter" card. Sourced from
 * PostgreSQL (orders.status) via the existing `/custom/orders-firebase/counter`
 * endpoint — replaces the retired Firestore `order-counter` onSnapshot subscription.
 * Missing statuses come back as 0.
 */
export const getOrdersStatusCounts = async (userId: string, connectorId: string) => {
  try {
    const idToken = await getIdTokenFromLocalStorage();
    const res = await fetch(`${API_SERVER_URL}/custom/orders-firebase/counter`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `${idToken}`,
      },
      body: JSON.stringify({ userId, connectorId }),
    });
    const body = await res.json();
    if (!res.ok || body?.isSuccess === false) {
      throw new Error(body?.message || "Failed to fetch order status counts");
    }
    const counts = body?.result?.updateCountData ?? {};
    return {
      isSucceed: true,
      result: {
        ExportComplete: counts.ExportComplete ?? 0,
        ExportFailed: counts.ExportFailed ?? 0,
        NotProcessed: counts.NotProcessed ?? 0,
        Imported: counts.Imported ?? 0,
      },
    };
  } catch (error: any) {
    await writeException(`ErrorMessage: ${error.message}, UserID: ${userId}, ConnectorID: ${connectorId}`);
    return {
      isSucceed: false,
      errorMessage: error?.message || "Failed to fetch order status counts",
    };
  }
};